import React from "react";
import { useCategory, useRelatedArticles } from "@elevio/kb-kit/lib/hooks";
import * as Article from "@elevio/kb-kit/lib/components/article";
import { faqArticleIds } from "../utils/constants";
function ArticleList({ className, isRelated, isAside: _isAside }) {
    const category = useCategory({ usePageCategory: false });
    const relatedArticles = useRelatedArticles();
    const HeadingTag = 'h2';
    return (<div className={className}>
      <HeadingTag className={!isRelated ? 'home-article-title' : 'related-articles'}>
        {isRelated ? 'Related Articles' : category && category.title}
        {/* <CategoryTitle > {category && category.title} </CategoryTitle> */}
        {/* <Trans i18nKey="article.relatedTitle">></Trans> */}
      </HeadingTag>
      <ul className="article-list">
        {isRelated ? (relatedArticles === null || relatedArticles === void 0 ? void 0 : relatedArticles.map((article) => (<li key={article.id} className="article-list-item home-article-info">
              <Article.Link articleId={article.id} className="article-list-link">
                <Article.Title articleId={article.id}/>
              </Article.Link>
            </li>))) : (faqArticleIds.map((article) => (<Article.IsNotActive key={article}>
              <Article.RenderFragment articleId={article}>
                <li className="article-list-item home-article-info">
                  <Article.Link articleId={article} className="article-list-link">
                    <Article.Title articleId={article}/>
                  </Article.Link>
                </li>
              </Article.RenderFragment>
            </Article.IsNotActive>)))}
      </ul>
    </div>);
}
export default ArticleList;
